<template>
    <div v-loading="loading" element-loading-text="Please don't leave the page! It is Paying" style="overflow-x: hidden;">
        <div class="center mb30" style="padding-top: 50px;">
            <p class="black fs38 fw500">{{ $t('step2').toUpperCase() }}</p>
            <span class="backyel dib divide"></span>
        </div>
        <div class="p1">
            <el-steps :active="step" align-center class="mb30" :class="$style.steps">
                <el-step v-for="(item, index) in steps" :key="index" :title="$t('step') + (index + 1)" :description="item.desc"></el-step>
            </el-steps>
			<reminderDialogVue :close="closeDialog" :p="reminderMsg" :requiredDialogVisible.sync = "requiredDialogVisible"></reminderDialogVue>
            <div v-show="step === 0">
				<floatBall :text="$t('b1')" @saveCallback="saveCallback"></floatBall>
				<uinput :title="$t('code') + $t('colon')" v-model="model['helper_code']" :full="true"></uinput>
				<div style="width: 400px"></div>
                <uinput :title="$t('pf1') + $t('colon')" v-model="model['helper_name']" :full="true" ></uinput>
                <div class="dib mb30 vat" style="width: 100%;">
                    <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('pf3') }}</p>
                    <p style="font-size: 23px; margin-right: -20px;">
                        <el-radio v-model="model['start_work_at']" label="As soon as possible">{{ $t('pf3a') }}</el-radio>
                        <el-radio v-model="model['start_work_at']" label="formatStartWorkDate">
                            <span>{{ $t('pf3b') }}</span>
                            <el-date-picker
                                v-model="startWorkDate"
                                type="date"
                                placeholder="选择日期" class="date" style="width: 140px;">
                            </el-date-picker>
                            <!-- <span class="pr" style="padding-left: 10px;font-size: 14px;">{{ formatStartWorkDate }}</span> -->
                        </el-radio>
                    </p>
                </div>
                <uinput :title="$t('pf4') + $t('colon')" v-model="model['employer_name']" :full="true"></uinput>
                <uinput :title="$t('pf51') + $t('colon')" :full="true" v-model="model['employer_mobile']">
                    <i class="el-icon-phone"></i>
                </uinput>
				<uinput :title="$t('email')" placeholder="123@gmail.com"  v-model="model['employer_email']"></uinput>
                <uinput :title="$t('pf41') + $t('colon')" v-model="model['employer_hkid']" placeholder="V0627000(1) "></uinput>
                <div class="dib mb30 vat mr4" style="width: 45%;">
                    <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('pf7') }}</p>
                    <p style="font-size: 23px; margin-right: -20px;">
                        <el-radio v-model="model['sign_document_type']" label="At Branch">{{ $t('pf7a') }}</el-radio>
                        <el-radio v-model="model['sign_document_type']" label="SF Express">{{ $t('pf7b') }}</el-radio>
                    </p>
                </div>
                <uinput :title="$t('pf8') + $t('colon')" :width="100" v-model="model['mailing_address']">
                    <i class="el-icon-location"></i>
                </uinput>
                
				
				<div class="showInLargeb">
				    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('paymentN1') }}</h2>
					<p class="fs18 fw500" style="margin-bottom: 10px;margin-top: 20px;">{{$t('paymentN2')}}</p>
				    <div style="margin-top: 40px;">
				        <p :class="$style.st1">
				            <span class="gray">{{ $t('paymentN3') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				            <span :class="$style.value">{{ model['helper_name'] }}</span>
				        </p>
						<p :class="$style.st1">
						    <span class="gray">{{ $t('paymentN4') }}</span><span class="gray" style="margin-right: 20px;">:</span>
						    <span :class="$style.value">{{ paidate }}</span>
						</p>
						<!-- <p :class="$style.st1">
						    <span class="gray">{{ $t('paymentN5') }}</span><span class="gray" style="margin-right: 20px;">:</span>
						    <span :class="$style.value">{{ csdate }}</span>
						</p> -->
				    </div>
					<uselect :title="$t('pSelectT')"  v-model="model['helperSType']" :options="hOptions">
					    
					</uselect>
				</div>
				<div class="showInSmallb">
				    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('paymentN1') }}</h2>
					<p class="fs18 fw500" style="margin-bottom: 10px;">{{$t('paymentN2')}}</p>
				    <div style="margin-top: 40px;">
				        <p :class="$style.st1">
				            <span class="gray">{{ $t('paymentN3') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				            <span :class="$style.value">{{ model['helper_name'] }}</span>
				        </p>
				    	<p :class="$style.st1">
				    	    <span class="gray">{{ $t('paymentN4') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				    	    <span :class="$style.value">{{ paidate }}</span>
				    	</p>
				    	<!-- <p :class="$style.st1">
				    	    <span class="gray">{{ $t('paymentN5') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				    	    <span :class="$style.value">{{ csdate }}</span>
				    	</p> -->
				    </div>
				    <uselect :title="$t('pSelectT')" :full="true" v-model="model['helperSType']" :options="hOptions">
				        
				    </uselect>
				</div>
            </div>
            <div v-show="step === 1" class="fw500 bigRadio">
                <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('aservice') }}</h2>
                <div style="border-bottom: 1px solid #222a33;color:#508098;line-height:2;" class="fs24" :class="$style.step1">
                    <p>{{ $t('renew5') }}</p>
                    <p >{{ $t('renew6') }}</p>
                </div>
            </div>
            <div v-show="step === 2" class="center">
				<p class="fs18" style="margin-top: 40px;">{{$t('payamount')}}</p>
				<p class="fs24 mb30">${{totalPrice}}</p>
				<p v-show="totalPrice != 0" >{{$t('pSelectPay')}}:</p>
				<div v-show="totalPrice != 0" :class="$style.verticalrg" style="margin-top: 50px;width: 13.375rem;margin: 0 auto;">
					<el-radio-group v-model="model['payType']">
						<el-radio  label="1" style="margin-bottom: 2.5rem;">
							<img src="../assets/paypay.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT1") }}</span>
						</el-radio>
						<br />
						<el-radio  label="2" style="margin-bottom: 2.5rem;">
							<img src="../assets/payment_ATM.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT2") }}</span>
						</el-radio>
						<br />
						<el-radio  label="3" style="margin-bottom: 2.5rem;">
							<img src="../assets/payment_FPS.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT3") }}</span>
						</el-radio>
						<br />
					</el-radio-group>
				</div>
				<div v-show="totalPrice == 0" >
					<el-button type="warning" size="large" style="width:11.25rem;" @click="onSureClick" :disabled="!canSubmit">
						{{$t('confirmOrder')}}
					</el-button>
				</div>
				
				<div v-show="totalPrice != 0">
					<div v-if="model['payType'] == 1">
						<div style="margin-top: 1.875rem;">
							<p v-if="err" class="red center" style="margin-bottom: 1.25rem;">{{err}}</p>
							<!-- 支付成功後不能再次支付 -->
							<a id='payLinks' href="#" style='display:none;'></a>
							<el-button type="info" size="large" style="width:11.25rem;" @click="onPayClick" :disabled="success">
							    <i class="el-icon-lock"></i>
							    {{$t('pay1')}}</el-button>
							<div v-if="success" class="yellow center" style="margin-top: 1.25rem;">
							    <p>{{ $t('paySuccess1') }}</p>
							    <p>{{ $t('paySuccess2') }}</p>
							    <p>{{ $t('paySuccess3') }}</p>
							</div>
						</div>
					</div>
					<div v-else-if="model['payType'] == 2">
						<amt></amt>
					</div>
					<div v-else>
						<fps></fps>
					</div>
				</div>
				
				<div v-show="model['payType'] != 1 && totalPrice != 0" :class="$style.credentialDiv">
					<p style="margin-top: 1.25rem;padding: 0 0.625rem;">{{ $t('amtf1') }}</p>
					<p style="padding: 0 0.625rem;">{{ $t('amtf2') }}</p>
					<div style="margin:1.25rem 0;">
						<span style="margin-right: 1.25rem;">
							<a @click="editAvatar" :class="$style.editbtn">{{$t('pfile')}}</a>
							<input style="display:none;" type="file" accept="image/*" ref="avatar" @change="onFileEdit">
						</span>
						<i v-show="model['credential'] != ''" class="el-icon-delete" style="cursor: pointer;" @click="delFile"></i>
					</div>
					<div>
						<img class="mcenter" :src="model['credential']" alt="" style="max-width: 37.5rem;">
					</div>
					<div style="margin-top: 1.25rem;">
						<el-button type="warning" size="large" style="width:11.25rem;" @click="onSureClick" :disabled="!canSubmit">
							{{$t('confirmOrder')}}
						</el-button>
					</div>
				</div>
				
                
                <template>
                    <p style="margin-top:2.5rem;">{{ $t('afterpay1') }}</p>
                    <p>{{ $t('afterpay2') }}</p>
                </template>
            </div>
            <div v-show="step === 3" class="gray" :class="$style.step3">
                <!-- <img :src="sendfileurl" alt="" style="width: 100%; margin-top:30px;margin-bottom:40px;"> -->
                <h1 class="fs24 center sendInfo">{{$t('l1')}}</h1>
                <div class="dflexx acsb" style="padding: 50px 0px;">
                    <div class="center mb30" style="width:300px;">
                        <img src="../assets/email.png" alt="" width="80">
                        <p class="black mt10">doc@goldenwin.com.hk</p>
                    </div>
                    <div class="center cp" style="width:300px;" @click="goWhatsappPay">
                        <img src="../assets/whatsapp.png" alt="" width="80">
                        <p class="black mt10">{{ $t('w1') }}</p>
                    </div>
                </div>
                <uinfo></uinfo>
            </div>
            <div class="dflex acsb" style="margin-top: 40px;">
                <ubutton :text="$t('pre')" :disabled="!canPre" @click="step--"></ubutton>
                <ubutton v-if="!isLast" :text="$t('next')" :disabled="!canNext" @click="clickStepNext"></ubutton>
                <ubutton v-else @click="$router.push('/index')" :text="$t('renew4')"></ubutton>
            </div>
        </div>
        <a @click="aClick" ref="btn" style="visbility: hidden;"></a>
    </div>
</template>
<script>
import { format } from 'date-fns';
import {companies} from '../data.js';
import moneyzh from '../assets/money.png';
import moneyen from '../assets/moneyen.png';
import {newPriceMap} from '../data.js';
import floatBall from '../components/FloatBall.vue';
import amt from '../components/amt.vue';
import fps from '../components/fps.vue';
import reminderDialogVue from '../components/reminderDialog.vue';
export default {
    name: 'Payment',
    props: {
        orderId: String,
    },
	components:{
		floatBall,
		amt,
		fps,
		reminderDialogVue,
	},
    data() {
        const lang = this.$i18n.locale;
		const tDate = new Date();
		const cDate = new Date();
		cDate.setDate(cDate.getDate() + 6);
		const hOptions = [];
		for(let n = 0; n <= 6; ++n) {
		    hOptions.push({
		        value: this.$t('pSelectN'+n),
		        text: this.$t('pSelectN'+n),
		        lable: this.$t('pSelectN'+n),
		    });
		}
        return {
			sType:0,
            step: 0,
            steps: [
                {desc: this.$t('step1')},
                {desc: this.$t('aservice')},
                {desc: this.$t('step2')},
                {desc: this.$t('step3')},
            ],
			hOptions,
            price: 0,  // price
            lang,
            money: lang === 'en' ? moneyen : moneyzh,
            startWork: '1',
            startWorkDate: new Date(),
			tableData:{},
            model: {
                sType: "",
                helper_code: "",
                helper_name: "",
                start_work_at: "As soon as possible",
                employer_name: "",
                employer_mobile: "",
				employer_email: "",
                employer_hkid: "",
                sign_document_type: 'SF Express',
                mailing_address: "",
				helperSType: "",
				payType: '1',
				credential: "",
            },
            err: '',
            loading: false,
            success: false,
            orderNo: '',
            cancel: false,
            url: '',
			paidate: tDate.toLocaleString('en-US', { month: 'short' }) + " " + tDate.getDate() + " " + tDate.getFullYear(),
			csdate: tDate.toLocaleString('en-US', { month: 'short' }) + " " + cDate.getDate() + " " + cDate.getFullYear(),
			canSubmit: true,
			reminderMsg: [
				this.$t('newPaymentRp1'),
			],
			requiredDialogVisible: false,
			
        }
    },
    computed: {
        formatStartWorkDate() {
            return format(this.startWorkDate, 'MM/dd/yyyy');
        },
        canPre() {
            return this.step !== 0 && !(this.step === 2 && this.orderNo);
        },
        canNext() {
            return this.step !== (this.steps.length - 1);
        },
        isLast() {
            return this.step === (this.steps.length - 1);
        },
        totalPrice() {
            return this.price ? +this.price : 0;
        }
    },
    watch: {
        step() {
            this.err = '';
            this.$top();
        },
        success(value) {
            if (value) {
                // this.$notify({
                //     title: this.$t('success'),
                //     message: this.$t('paySuccess'),
                //     type: 'success'
                // });
                this.$alert(this.$t('paySuccess'), this.$t('success'), {
                    type: 'success'
                });
            }
        },
		model:{
			handler(val, oldVal){
				this.postCacheTable();
			},
			deep:true
		},
		'model.helperSType':{
			handler(val, oldVal){
				const sType = val.slice(0,1);
				if (this.isNumeric(sType)){
					this.sType = sType;
					this.model.sType = sType;
				}else{
					this.sType = 0;
					this.model.sType = sType;
				}
				this.price = newPriceMap[this.sType] || 0;
			}
		},
    },
    created() {
        this.$top();
        this.orderNo = this.$route.query['order_no'];
        this.cancel = this.$route.query['cancel'];
        this.initOrder();
		this.getCacheTable();
    },
    methods: {
		closeDialog() {
			this.requiredDialogVisible = false;
		},
		getConfirmCacheInfo() {
			this.$service.interviewGetConfirmInfo().then((res)=>{
				this.model.helper_code = res.info.helper_code;
				this.model.helper_name = res.info.helper_name;
				if(res.info.employer_name) {
					this.model.employer_name = res.info.employer_name;
				}
				if(res.info.employer_mobile) {
					this.model.employer_mobile = res.info.employer_mobile;
				}
				if(res.info.employer_email) {
					this.model.employer_email = res.info.employer_email;
				}
				if(res.info.employer_hkid) {
					this.model.employer_hkid = res.info.employer_hkid;
				}
			});
		},
		clickStepNext() {
			if(this.step == 0 && this.sType == 0){
				this.$message.warning('Please Select Your category');
				return;
			}
			if (this.step === 0) {
				if (
					this.model.helper_code == '' ||
					this.model.helper_name == '' || 
					this.model.employer_name == '' ||
					this.model.employer_mobile == '' ||
					this.model.employer_email == '' ||
					this.model.employer_hkid == '' ||
					this.model.mailing_address == '' ||
					this.model.helperSType == '' 
				) {
					this.requiredDialogVisible = true; //显示弹框
					return;
				}
			}
			
			this.step++
			
		},
		isNumeric (value) {
		  return !isNaN(value);
		},
		editAvatar() {
		    this.$refs.avatar.click();
		},
		onFileEdit(files){
			const fileList = this.$refs.avatar.files;
			let reader = new FileReader();     //html5读文件
			reader.readAsDataURL(fileList[0]); //转BASE64
			reader.onload=(e) => {        //读取完毕后调用接口
			    let file = e.target.result;
				this.model['credential'] = file;
			};
		},
		delFile(){
			this.$refs.avatar.value = "";
			this.model['credential'] = "";
		},
		saveCallback(){
			var data = this.model;
			data.startWorkDate = format(this.startWorkDate, 'MM/dd/yyyy');
			const params = {
				type:this.type,
				table:JSON.stringify(data)
			}
			this.$service.postCacheTable(params);
		},
        initOrder() {
            if (this.orderNo) {
                this.step = 2;
                if (!this.cancel) {
                    this.err = '';
                    this.loading = true;
                    this.success = false;
                    this.checkOrder(this.orderNo);
                } else { // 取消支付
                    this.$notify({
                        title: this.$t('cancel'),
                        message: this.$t('cancelpay'),
                        type: 'warning'
                    });
                    this.$service.checkPay({order_number: this.orderNo}).then((res) => {
                        this.price = res.data.total_money;
                    })
                    this.err = this.$t('cancelpay');
                }
            } else if (this.orderId) {
                this.step = 2;
            }
        },
        aClick() {
            window.open(this.url);
        },
		onSureClick(){
			this.err = '';
			this.loading = true;
			this.canSubmit = true;
			if (this.model['payType'] != 1 && this.model['credential'] == "") {
				this.loading = false;
				this.$message.error('Non online payment,Please Upload the receipts after you made the payment.');
				return
			}
			
			if (this.model['start_work_at'] === 'formatStartWorkDate') {
			    this.model['start_work_at'] = this.formatStartWorkDate;
			}
			this.model['total_money'] = this.totalPrice;
			
			let emptyfi = Object.keys(this.model).find((key) => this.model[key] === undefined);
			// // DIRE HIRE OVERSEAS:   No need to require “Helper Code” to pay
			// if(this.type === '4') {
			//     emptyfi = emptyfi.filter((item) => item != 'helper_code');
			// }
			if (emptyfi && emptyfi.length > 0) {
			    this.loading = false;
				this.$message.error(emptyfi + ' is required');
			} else {
			
			    // let openPay = false; // 防止1000ms报错
			    // var winRef = window.open();
			    this.$service.newAddContract(this.model).then((res) => {
					this.loading = false;
					this.canSubmit = false;
					this.$message('Submit Success')
			    }).catch((res = {}) => {
						this.$message({
						  message: res.message || 'order error',
						  type: 'error'
						});
			            this.loading = false;
			    });
			}
			
		},
        onPayClick() {
            // window.open('https://www.baidu.com');
            // return;
            this.err = '';
            this.loading = true;
            this.success = false;

            var id = this.orderNo || this.orderId;
            if (id) {
                const params = {order_number: id};
                const payUrl = this.$service.getPay(params);
				let obj = document.getElementById('payLinks');
				obj.href = payUrl;
				obj.click();
                this.checkOrder(id);
                return;
            }

            if (this.model['start_work_at'] === 'formatStartWorkDate') {
                this.model['start_work_at'] = this.formatStartWorkDate;
            }
            this.model['total_money'] = this.totalPrice;
			console.log(this.model)
            let emptyfi = Object.keys(this.model).find((key) => this.model[key] === undefined);
            // // DIRE HIRE OVERSEAS:   No need to require “Helper Code” to pay
            // if(this.type === '4') {
            //     emptyfi = emptyfi.filter((item) => item != 'helper_code');
            // }
			console.log(emptyfi)
            if (emptyfi && emptyfi.length > 0) {
                this.loading = false;
                this.err = emptyfi + ' is required';
            } else {
                // let openPay = false; // 防止1000ms报错
                // var winRef = window.open();
                this.$service.newAddContract(this.model).then((res) => {
                    const params = {order_number: res.data['order_number']};
                    const payUrl = this.$service.getPay(params);
					let obj = document.getElementById('payLinks');
					obj.href = payUrl;
					obj.click();
                    // this.$service.pay(params);
                    // winRef.location = this.$service.getPay(params);
                    // openPay = true;
                    this.checkOrder(res.data['order_number']);
                }).catch((res = {}) => {
                    // if (openPay === false) {
                        // winRef.close();
                        this.err = res.message || 'order error';
                        this.loading = false;
                    // }
                });
            }
        },
        checkOrder(orderNo) {
            const _check = (params) => {
                this.$service.checkPay(params).then((res) => {
                    this.price = res.data.total_money;
                    if (res.data.status) { // 支付成功
                        this.loading = false;
                        this.success = true;
                    } else {
                        setTimeout(() => _check(params), 3000);
                    }
                }).catch(() => {
                    this.err = 'error pay';
                    this.loading = false;
                });
            };
            _check({order_number: orderNo});
        },
		getCacheTable(){
			const params = {
				type:this.type
			}
			this.$service.getCacheTable(params).then((res)=>{
				// this.tableData = res.data;
				if(res.status != 200) return;
				var tableData = res.data;
				if(tableData != '') {
					Object.keys(tableData).forEach(k=>{
						if(typeof(tableData[k]) === 'number'){
							tableData[k] = tableData[k].toString();
						}
						if(k == 'helper_main_duties'){
							if(tableData[k] != ''){
								if(typeof(tableData[k]) === 'object'){
									this.model[k] = tableData[k];
								}
								if(typeof(tableData[k]) === 'string'){
									this.model[k] = JSON.parse(tableData[k]);
								}
							}
						}else if(k == 'startWorkDate'){
							this.startWorkDate = new Date(tableData[k]);
						}else if(k == 'deliveryDate'){
							this.deliveryDate = new Date(tableData[k]);
						}else{
							this.model[k] = tableData[k];
						}
					})
				} 
				this.getConfirmCacheInfo();
			})
		},
		postCacheTable(){
			const params = {
				type:this.type,
				table:JSON.stringify(this.model)
			}
			this.$service.postCacheTable(params);
		}
    }
}
</script>
<style module>
.editbtn {
	color: #f3b707e6;
	cursor: pointer;
	text-decoration: underline;
	transition:all .4s;
	-moz-transition:all .4s;
	-webkit-transition:all .4s;
	-o-transition:all .4s;
}
.incost {
    margin-top: 10px;
    margin-left: 37px;
    font-size: 20px;
}
.value {
    flex: 1.5;
    padding-left: 10px;
}
.step1 {
    padding: 100px 0px;
}
.step3 {
    margin: 100px;
}
.money {
    width: 40px;
    vertical-align: -3px;
}
.st1 {
	margin: 10px 0;
}
.vertical {
  display: block;
  margin: 20px 0;
}
.verticalrg {
  display: flex;
  flex-direction: column;
}
.credentialDiv {
	background-color: #F5F5F5;
	width: 40.625rem;
	min-height: 12.5rem;
	text-align: center;
	margin: 20px auto;
	padding-top: 10px;
	padding-bottom: 20px;
}
@media screen and (max-width: 770px) {
	.credentialDiv {
		background-color: #F5F5F5;
		width: 20.625rem;
		min-height: 12.5rem;
		text-align: center;
		margin: 20px auto;
		padding-top: 10px;
		padding-bottom: 20px;
	}
    .step1 {
        padding: 30px 0px;
    }
    .step3 {
        margin: 20px;
    }
    .money {
        width: 35px;
        vertical-align: -3px;
    }
}
</style>
